<template>
  <el-select
    v-model="paymentTermModel"
    @change="paymentTermChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.PAYMENT_TERMS')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getPaymentTerms"
    :loading="loading"
  >
    <el-option
      v-if="showAll"
      :value="null"
      :label="$t('COMMON.ALL_PAYMENT_TERMS')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="paymentTerm in paymentTerms"
      :key="paymentTerm.id"
      :value="paymentTerm.id"
      :label="`${paymentTerm.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "payment-term-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    paymentTerm: {
      type: String,
      default: null,
      description: "PaymentTerm id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
  },

  data() {
    return {
      paymentTermModel: this.paymentTerm,
      paymentTerms: {},
    };
  },

  setup() {},

  created() {
    this.getPaymentTerms(null, this.paymentTerm);
  },

  methods: {
    async getPaymentTerms(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { name: encodeURIComponent(query) } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        if (this.filterReseller) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              reseller: this.filterReseller,
            },
          };
        }

        await this.$store.dispatch("paymentTerms/list", params);
        const paymentTermsArr = await this.$store.getters["paymentTerms/list"];
        this.paymentTerms = {};
        paymentTermsArr.forEach((paymentTerm) => {
          this.paymentTerms[paymentTerm.id] = paymentTerm;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    paymentTermChanged(paymentTerm) {
      this.$emit("paymentTermChanged", paymentTerm);
    },
  },

  watch: {
    paymentTerm(paymentTerm) {
      if (paymentTerm) {
        this.paymentTermModel = paymentTerm;
        if (paymentTerm !== this.paymentTermModel) {
          this.getPaymentTerms(null, paymentTerm);
        }
      } else {
        this.paymentTermModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getPaymentTerms();
    },
    filterReseller(filterReseller) {
      this.getPaymentTerms();
    },
  },
};
</script>
